<template>
  <div class="account-phone-update" :class="{ 'account-phone-update--bank-link': bankLink }">
    <div v-if="error && !bankLink" class="account-phone-update__error">
      {{ error }}
    </div>

    <!-- Step 1: Enter Phone Number -->
    <div v-if="step === 'input'" class="account-phone-update__step">
      <p v-if="!bankLink" class="account-phone-update__description">
        {{ inputDescription }}
      </p>
      <alert-box v-if="error && bankLink" class="account-phone-update__alert" level="warning">
        {{ error }}
      </alert-box>

      <div class="account-phone-update__field">
        <label class="account-phone-update__label" :for="inputId">Phone Number</label>
        <div class="account-phone-update__input-wrapper">
          <input
            :id="inputId"
            type="tel"
            v-model="phoneNumber"
            class="account-phone-update__input"
            placeholder="+1 (555) 555-5555"
            autocomplete="tel"
            @input="$v.phoneNumber.$touch()"
            @blur="$v.phoneNumber.$touch()"
          />
          <div v-if="phoneError" class="account-phone-update__field-error">
            {{ phoneError }}
          </div>
        </div>
        <p v-if="bankLink" class="account-phone-update__hint">
          US mobile numbers only. Landline, VoIP and prepaid numbers aren't supported.
        </p>
      </div>

      <button
        class="button button--primary button--full-width"
        type="button"
        :disabled="!canSendCode"
        @click="sendCode"
      >
        {{ isSending ? 'Sending...' : 'Send Verification Code' }}
      </button>
    </div>

    <!-- Step 2: Enter Verification Code -->
    <div v-if="step === 'verify'" class="account-phone-update__step">
      <p class="account-phone-update__description" :id="inputId + '-code'">
        Enter the 6-digit code sent to {{ verificationDestination }}.
      </p>
      <alert-box v-if="error && bankLink" class="account-phone-update__alert" level="warning">
        {{ error }}
      </alert-box>

      <div class="account-phone-update__field" v-if="bankLink">
        <code-input
          ref="codeInput"
          role="group"
          :aria-labelledby="inputId + '-code'"
          v-model="verificationCode"
          :error="!!error"
          :disabled="isVerifying"
          :loading="isVerifying"
          @complete="verifyCode"
          @submit="verifyCode"
        />
      </div>
      <div class="account-phone-update__field" v-else>
        <label class="account-phone-update__label">Verification Code</label>
        <input
          type="text"
          v-model="verificationCode"
          class="account-phone-update__input"
          placeholder="000000"
          maxlength="6"
          inputmode="numeric"
          autocomplete="one-time-code"
          @keyup.enter="verifyCode"
        />
      </div>

      <div class="account-phone-update__resend">
        <button
          class="account-phone-update__resend-btn"
          type="button"
          :disabled="secondsUntilResend > 0"
          @click="sendCode"
        >
          {{ secondsUntilResend > 0 ? `Resend code in ${secondsUntilResend}s` : 'Resend code' }}
        </button>
        <button
          v-if="bankLink"
          class="account-phone-update__cancel-btn"
          type="button"
          @click="onCancel"
        >
          Cancel
        </button>
      </div>

      <button
        class="button button--primary button--full-width"
        type="button"
        :disabled="!canVerify"
        @click="verifyCode"
      >
        {{ isVerifying ? 'Verifying...' : verificationActionText }}
      </button>
    </div>

    <div class="account-phone-update__footer" v-if="!bankLink || step === 'input'">
      <button class="account-phone-update__cancel-btn" type="button" @click="onCancel">
        Cancel
      </button>
    </div>
  </div>
</template>

<script src="./account-phone-update.js"></script>
<style src="./account-phone-update.scss" lang="scss"></style>
